import { render, staticRenderFns } from "./traffic-illegal-parking.vue?vue&type=template&id=6835203c&scoped=true&"
import script from "./traffic-illegal-parking.vue?vue&type=script&lang=ts&"
export * from "./traffic-illegal-parking.vue?vue&type=script&lang=ts&"
import style0 from "./traffic-illegal-parking.vue?vue&type=style&index=0&id=6835203c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835203c",
  null
  
)

export default component.exports